import { useLocation } from 'react-router-dom'
import { useIsMobile } from '@/hooks/useMediaQuery'

/** Query param that opens a conversation on mobile; without it `/chat` is the thread list. */
export const CHAT_THREAD_PARAM = 'thread'

/** Opens the main conversation directly (on phones, past the thread list). */
export const CHAT_THREAD_PATH = `/chat?${CHAT_THREAD_PARAM}=cmo`

/** True on the phone-width thread list at `/chat` (no conversation open). */
export function useIsChatHome(): boolean {
  const isMobile = useIsMobile()
  const { pathname, search } = useLocation()
  if (!isMobile || pathname !== '/chat') return false
  const params = new URLSearchParams(search)
  return !params.has(CHAT_THREAD_PARAM) && !params.has('session')
}
